import './LogIn.scss';
import { FormInput } from 'components/FormInput/FormInput';
import { FormLayout } from 'layouts/FormLayout/FormLayout';
import { Link, useNavigate } from 'react-router-dom';
import { PasswordInput } from 'components/PasswordInput/PasswordInput';
import { useAuth } from 'context/useAuth';
import { useEffect, useState } from 'react';
import Button from 'components/Button/Button';
import FormRow from 'components/FormRow/FormRow';
import NumberOne from 'assets/icons/number-one.svg';
import { delaySeconds } from 'functions/deviceStatusUtils';
import { sendPasswordResetEmail } from '@firebase/auth';
import { infoAsync } from 'functions/notification';

export default function LogIn() {
  const navigate = useNavigate();
  const { authorisedUser, handleLogin, errors, submitting, firebaseAuth } = useAuth();
  const [forgotPasswordText, setForgotPasswordText] = useState('Forgot Password');

  const onForgotPassword = async () => {
    if (!formData.email) {
      return infoAsync('Please specify your email address');
    }
    try {
      setForgotPasswordText('Sending password teset email ...');
      await sendPasswordResetEmail(firebaseAuth!, formData.email);
      setForgotPasswordText('Password reset email sent.');
      await delaySeconds(2);
    } catch (error: any) {
      setForgotPasswordText('Failed to send password reset email.');
      await delaySeconds(2);
    } finally {
      setForgotPasswordText('Forgot Password');
    }
  };

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  useEffect(() => {
    document.title = 'Login | Titan Secure';

    if (authorisedUser) {
      navigate('/agent');
    }
  });

  function submitDisabled() {
    return formData.email.length === 0 || formData.password.length === 0;
  }

  function handleInputChange(e: any) {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  }

  return (
    <div className='login'>
      <FormLayout>
        <FormLayout.Main>
          <div className='narrow-container--center-text'>
            <img src={NumberOne} alt='Number 1' />
            <h2>
              SA’s 1st <br /> Multi-layered <br /> Vehicle Safety Solution
            </h2>
          </div>
          <FormRow>
            <FormInput
              id='email'
              type='email'
              label='Email address'
              onChange={handleInputChange}
              value={formData.email}
            />
          </FormRow>
          <FormRow>
            <PasswordInput
              id='password'
              label='Your password'
              onChange={handleInputChange}
              value={formData.password}
            />
            <small className='form-field__message form-field__message--error'>
              {errors}
            </small>
          </FormRow>
          <div className='login__links'>
            <Link to={'#'} aria-label='Forgot Password' onClick={onForgotPassword} aria-disabled={forgotPasswordText !== "Forgot Password"}>
              {forgotPasswordText}
            </Link>
          </div>
        </FormLayout.Main>
        <FormLayout.Footer>
          <Button
            label='Login'
            fullWidth
            disabled={submitDisabled() || submitting}
            onClick={() => handleLogin(formData)}
          />
        </FormLayout.Footer>
      </FormLayout>
    </div>
  );
}
